import { render, staticRenderFns } from "./TutorialProfileFinish.vue?vue&type=template&id=9bd2922a"
import script from "./TutorialProfileFinish.vue?vue&type=script&lang=js"
export * from "./TutorialProfileFinish.vue?vue&type=script&lang=js"
import style0 from "./TutorialProfileFinish.vue?vue&type=style&index=0&id=9bd2922a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports